export default "__VITE_ASSET__D8Hp_qIX__"